export default __webpack_public_path__ + "static/media/aboutBg.231485ea.svg";